/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import MobileButton from 'bundles/composable-page-header/components/mobile-menu-items/MobileButton';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  separator: css`
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    height: 0;
    list-style-type: none;
    margin-top: var(--cds-spacing-100);
    padding: 0 0 var(--cds-spacing-100);
  `,
};

const CourseraPlusMenuItem = () => {
  const track = useTracker();

  return (
    <React.Fragment>
      <li css={styles.separator} />
      <MobileButton
        href="/courseraplus"
        label={_t('Coursera Plus')}
        name="coursera_plus"
        onButtonClick={() => {
          track('click_page_tab', { pageTab: { name: 'logged_out_coursera_plus' } });
        }}
      />
    </React.Fragment>
  );
};

export default CourseraPlusMenuItem;
